/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BadgeTagContainer_settings = {
    readonly badges: {
        readonly staffLabel: string;
        readonly adminLabel: string;
        readonly moderatorLabel: string;
        readonly memberLabel: string;
    };
    readonly " $refType": "BadgeTagContainer_settings";
};
export type BadgeTagContainer_settings$data = BadgeTagContainer_settings;
export type BadgeTagContainer_settings$key = {
    readonly " $data"?: BadgeTagContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"BadgeTagContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BadgeTagContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "BadgeConfiguration",
            "kind": "LinkedField",
            "name": "badges",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "staffLabel",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "adminLabel",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moderatorLabel",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "memberLabel",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'bf97e8c4d8bcc695bb6e46934a887126';
export default node;
